import { z } from 'zod';

import { MoneyCentsStringSchema } from './place-customer.schemas.js';

export const PartySummaryMaintenanceStatusSchema = z.enum(['OVERDUE', 'DUE_SOON', 'OK', 'UNKNOWN']);

export type PartySummaryMaintenanceStatus = z.infer<typeof PartySummaryMaintenanceStatusSchema>;

export const GetPartySummaryQuerySchema = z.object({
  placeId: z.uuid().optional(),
});

export type GetPartySummaryQuery = z.infer<typeof GetPartySummaryQuerySchema>;

export const PartySummaryCreditSchema = z.object({
  availableCents: MoneyCentsStringSchema.nullable(),
  placeLimitCents: MoneyCentsStringSchema.nullable(),
  tenantLimitCents: MoneyCentsStringSchema.nullable(),
});

export const PartySummaryReceivablesSchema = z.object({
  openCents: MoneyCentsStringSchema,
  overdueCents: MoneyCentsStringSchema,
});

export const PartySummaryVehicleSchema = z.object({
  customerVehicleId: z.uuid(),
  plate: z.string().nullable(),
  description: z.string().nullable(),
  maintenanceStatus: PartySummaryMaintenanceStatusSchema,
});

export const GetPartySummaryResponseSchema = z.object({
  partyId: z.uuid(),
  orderCount: z.number().int().nonnegative(),
  ltvCents: MoneyCentsStringSchema,
  ticketAverageCents: MoneyCentsStringSchema,
  lastDeliveredAt: z.iso.datetime().nullable(),
  credit: PartySummaryCreditSchema,
  receivables: PartySummaryReceivablesSchema,
  vehicles: z.array(PartySummaryVehicleSchema),
});

export type GetPartySummaryResponse = z.infer<typeof GetPartySummaryResponseSchema>;

export type PartySummaryCredit = z.infer<typeof PartySummaryCreditSchema>;

export type PartySummaryReceivables = z.infer<typeof PartySummaryReceivablesSchema>;

export type PartySummaryVehicle = z.infer<typeof PartySummaryVehicleSchema>;

export const GetInactiveCustomersSummaryQuerySchema = z.object({
  thresholdDays: z.coerce.number().int().positive().default(90),
});

export type GetInactiveCustomersSummaryQuery = z.infer<
  typeof GetInactiveCustomersSummaryQuerySchema
>;

export const GetInactiveCustomersSummaryResponseSchema = z.object({
  inactiveCount: z.number().int().nonnegative(),
  thresholdDays: z.number().int().positive(),
});

export type GetInactiveCustomersSummaryResponse = z.infer<
  typeof GetInactiveCustomersSummaryResponseSchema
>;
